import { getReverseProposals as getReverseProposalsApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  GetReverseProposalsServiceRequest,
  GetReverseProposalsServiceResponse,
} from './get-reverse-proposals.dto';
import {
  GetReverseProposalsServiceRequestSchema,
  GetReverseProposalsServiceResponseSchema,
} from './get-reverse-proposals.dto';

export const getReverseProposalsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetReverseProposalsServiceRequestSchema),
    async (
      request: GetReverseProposalsServiceRequest,
    ): Promise<GetReverseProposalsServiceResponse> => {
      const apiResponse = await getReverseProposalsApi(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '캠페인 역제안 목록 조회에 실패했습니다.');
      }

      const hasNextPage = apiResponse.link?.next !== null && apiResponse.link?.next !== undefined;
      const nextPage = hasNextPage ? request.page + 1 : undefined;

      return {
        list: apiResponse.data.list,
        total: apiResponse.link?.total ?? 0,
        pagination: {
          currentPage: request.page,
          pageSize: request.size,
          hasNextPage,
          nextPage,
        },
      };
    },
    validateServiceResponse(GetReverseProposalsServiceResponseSchema),
  ),
);
